import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Wrench, Warning } from "@phosphor-icons/react";

/**
 * ApplianceIQChip — small callout for JobDetail / property pages.
 * Only renders when the property has 1+ actionable OR 1+ aging appliance.
 */
export default function ApplianceIQChip({ address }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!address || address.length < 3) return;
    let alive = true;
    api.get("/appliance-iq/for-property", { params: { address } })
      .then(r => { if (alive) setData(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, [address]);

  if (!data) return null;
  const total = (data.actionable || 0) + (data.aging || 0);
  if (total === 0) return null;

  const severe = (data.actionable || 0) > 0;
  return (
    <Link
      to="/admin/appliance-iq"
      data-testid="appliance-iq-chip"
      className={`inline-flex items-center gap-2 h-9 px-3 border-2 rounded-md text-xs font-black uppercase tracking-widest ${
        severe
          ? "border-red-500 bg-red-50 text-red-800 hover:bg-red-100"
          : "border-orange-400 bg-orange-50 text-orange-800 hover:bg-orange-100"
      }`}>
      {severe ? <Warning weight="fill" size={14}/> : <Wrench weight="fill" size={14}/>}
      ApplianceIQ · {data.actionable > 0 && `🔥 ${data.actionable} to replace`}{data.actionable > 0 && data.aging > 0 && " · "}{data.aging > 0 && `⚠️ ${data.aging} aging`}
      {data.top?.[0] && (
        <span className="hidden sm:inline text-[10px] font-bold opacity-80 truncate max-w-[180px]">
          top: {data.top[0].name} ({data.top[0].age_pct}%)
        </span>
      )}
    </Link>
  );
}
